import { render, staticRenderFns } from "./BannerOneColumn.vue?vue&type=template&id=472ce4c6&"
import script from "./BannerOneColumn.vue?vue&type=script&lang=js&"
export * from "./BannerOneColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports